import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import type { ClientAssetFieldMatchInfoFragment } from '@frameio/graphql-client/generated';
import { ClientAssetFieldMatchInfo } from '@frameio/graphql-client/generated';

export const useClientAssetFieldMatchInfo = () => {
  const { cache } = useApolloClient();

  const setClientAssetFieldMatchInfo = useCallback(
    (
      clientFieldMatch: Omit<ClientAssetFieldMatchInfoFragment, '__typename'>
    ) => {
      cache.writeFragment({
        fragment: ClientAssetFieldMatchInfo,
        fragmentName: 'ClientAssetFieldMatchInfo',
        data: {
          __typename: 'ClientAssetFieldMatch',
          id: clientFieldMatch.id,
          fieldName: clientFieldMatch.fieldName,
        },
        broadcast: true,
        overwrite: true,
      });
    },
    [cache]
  );

  const clearClientAssetFieldMatchInfo = useCallback(
    (assetId: string) => {
      cache.evict({
        id: cache.identify({
          __typename: 'ClientAssetFieldMatch',
          id: assetId,
        }),
        broadcast: true,
      });
    },
    [cache]
  );

  return {
    setClientAssetFieldMatchInfo,
    clearClientAssetFieldMatchInfo,
  };
};
